export enum Status {
  Info = 1,
  Error,
  Success,
}
